import { render, staticRenderFns } from "./FixedCart.vue?vue&type=template&id=10b001d5&scoped=true&v-if=getGameConsole%3D%3D%3D'default'"
import script from "./FixedCart.vue?vue&type=script&lang=js"
export * from "./FixedCart.vue?vue&type=script&lang=js"
import style0 from "./FixedCart.vue?vue&type=style&index=0&id=10b001d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b001d5",
  null
  
)

export default component.exports